import { render, staticRenderFns } from "./slim.vue?vue&type=template&id=40f03182&"
import script from "./slim.vue?vue&type=script&lang=js&"
export * from "./slim.vue?vue&type=script&lang=js&"
import style0 from "./slim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports